/* eslint-disable global-require */
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { mapLocaleForMoment } from '@bibliocommons/utils-localization';
import { getFeatureStatuses } from 'app/selectors/FeatureTogglzSelector';
import ApplicationContext from './ApplicationContext';

if (!global.Intl) global.Intl = require('intl');

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/dist/locale-data/en');
  require('@formatjs/intl-pluralrules/dist/locale-data/es');
  require('@formatjs/intl-pluralrules/dist/locale-data/fr');
  require('@formatjs/intl-pluralrules/dist/locale-data/ja');
  require('@formatjs/intl-pluralrules/dist/locale-data/ru');
  require('@formatjs/intl-pluralrules/dist/locale-data/zh');
  require('@formatjs/intl-pluralrules/dist/locale-data/fil');
  require('@formatjs/intl-pluralrules/dist/locale-data/vi');
}
if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/en');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/es');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/fr');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/ja');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/ru');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/zh');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/fil');
  require('@formatjs/intl-relativetimeformat/dist/locale-data/vi');
}

function mapStateToProps(state) {
  return {
    localization: state.get('localization').toJS(),
    coreCdnHost: state.getIn(['app', 'coreAssets', 'cdnHost']),
    mobileApp: state.getIn(['app', 'mobileApp'], false),
    baseURL: state.getIn(['app', 'baseURL']),
    features: getFeatureStatuses(state)
  };
}

/** @extends React.Component */
class ApplicationContainer extends BcReactComponent {
  constructor(props) {
    super(props);
    moment.locale(mapLocaleForMoment(props.localization.currentLanguage));
    this.state = {
      hydrated: false
    };
  }

  getChildContext() {
    return {
      baseURL: this.props.baseURL,
      coreCdnHost: this.props.coreCdnHost,
      mobileApp: this.props.mobileApp,
      features: this.props.features,
      hydrated: this.state.hydrated
    };
  }

  componentDidMount() {
    this.setState({ hydrated: true });
  }

  render() {
    const { children, localization } = this.props;

    return (
      <IntlProvider
        messages={localization.messages}
        locale={localization.currentLanguage}
        defaultLocale={localization.currentLanguage}
      >
        <ApplicationContext.Provider value={this.getChildContext()}>{children}</ApplicationContext.Provider>
      </IntlProvider>
    );
  }
}

ApplicationContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  localization: PropTypes.shape({
    messages: PropTypes.objectOf(PropTypes.string),
    currentLanguage: PropTypes.string
  }).isRequired,
  baseURL: PropTypes.string.isRequired,
  coreCdnHost: PropTypes.string.isRequired,
  mobileApp: PropTypes.bool.isRequired,
  features: ImmutablePropTypes.map.isRequired
};

ApplicationContainer.childContextTypes = {
  baseURL: PropTypes.string.isRequired,
  coreCdnHost: PropTypes.string.isRequired,
  mobileApp: PropTypes.bool.isRequired,
  features: ImmutablePropTypes.map.isRequired,
  hydrated: PropTypes.bool.isRequired
};

export default connect(mapStateToProps)(ApplicationContainer);
